/*global App */

Components.Energy.Switcher = function () {
    this.storage = {
        data: {},
        storageKey: "enmag-switcher",
        get: function(key, defaultValue) {
            defaultValue = defaultValue || null;
            if (typeof this.data[key] !== "undefined") return this.data[key];
            return defaultValue;
        },
        set: function(key, value) {
            this.data[key] = value;
            localStorage.setItem(this.storageKey, JSON.stringify(this.data));
        }
    };

    this.client = null;
    this.panels = {};

    this.initStorage = function() {
        var data = localStorage.getItem(this.storage.storageKey);
        if (data !== null) this.storage.data = JSON.parse(data);
    };

    this.clearStorage = function() {
        this.storage.data = {};
        localStorage.removeItem(this.storage.storageKey);
    };

    this.initPanels = function() {
        this.client = document.getElementById("frm-management-filterForm");

        var opened = this.storage.get(this.client.value);
        if (opened === null) {
            opened = [];
            this.storage.set(this.client.value, opened);
        }

        this.panels = document.querySelectorAll("a.panel-heading");
        for (var i = 0; i < this.panels.length; i++) {
            var panel = this.panels[i];
            var id = panel.getAttribute("href");
            if (opened.indexOf(id) !== -1) {
                var collapse = document.getElementById(id.substr(1));
                collapse.classList.add("in");
            }
        }
    };

    this.events = function() {
        var _this = this;
        for (var i = 0; i < this.panels.length; i++) {
            var panel = this.panels[i];
            panel.addEventListener("click", function(e) {
                var link = e.currentTarget;
                setTimeout(function() {
                    var opened = _this.storage.get(_this.client.value);
                    var id = link.getAttribute("href");
                    var collapse = document.getElementById(id.substr(1));
                    if (collapse.classList.contains("in")) {
                        opened.push(id);
                    } else {
                        opened.splice(opened.indexOf(id), 1);
                    }
                    _this.storage.set(_this.client.value, opened);
                }, 500);
            });
        }
    };

    this.initStorage();
};
